import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { UseAuth, hasValidAuthSession } from 'src/auth/AuthContext';

interface AuthProps {
  children: ReactNode;
}

const AuthClient: FC<AuthProps> = ({ children }) => {

  const { isAuthenticated } = UseAuth();

  if (isAuthenticated && hasValidAuthSession()) { 
    return <Navigate to="/inicio" replace />
  }

  return (
    <>{children}</>
  )
}

AuthClient.propTypes = {
  children: PropTypes.node as any
}

export default AuthClient